import type { Translations } from './zh';

export const id: Translations = {
  bubble: {
    open: 'Buka obrolan',
    close: 'Tutup obrolan',
    badge: 'Daring',
    dragHint: 'Tekan lama untuk menggeser',
  },
  panel: {
    closeAria: 'Tutup panel obrolan',
    languageAria: 'Pilih bahasa',
    welcomeFallback: 'Halo, ada yang bisa saya bantu?',
    quickQuestionsTitle: 'Anda dapat mencoba menanyakan pertanyaan berikut',
    quickAskTitle: 'Pertanyaan cepat',
    inputPlaceholder: 'Ketik pertanyaan Anda...',
    sendButton: 'Kirim',
    sendAria: 'Kirim pesan',
    onlineStatus: 'Daring',
    thinkingAria: 'Sedang berpikir',
    aiBusyHint: 'Agen sedang membalas, mohon tunggu…',
    leadReopenHint: 'Bila perlu, tinggalkan info kontak di sini',
    startChat: 'Mulai konsultasi',
    welcomeQuickHint: 'Kenali sekilas',
    videoPreparing: 'Menyiapkan video…',
    newMessageTitle: '💬 Pesan baru',
    newMessageBody: 'Anda memiliki pesan baru. Klik untuk melihat.',
  },
  roles: {
    visitor: 'Pengunjung',
    ai: 'Asisten AI',
    human: 'Agen',
    system: 'Sistem',
  },
  web: {
    aiChat: 'Dukungan AI',
    humanChat: 'Agen',
    switchToHuman: 'Hubungkan ke agen',
    switchToAI: 'Kembali ke AI',
    resetChat: 'Mulai ulang',
    commonQuestions: 'Pertanyaan umum',
    faqTitle: 'Pertanyaan yang sering diajukan',
    selectLanguage: 'Pilih bahasa',
    maximize: 'Maksimalkan',
    restore: 'Pulihkan',
    offlineLabel: 'Luring',
    aiGreeting: 'Halo! Saya asisten AI. Ada yang bisa saya bantu?',
    humanGreeting: 'Halo, Anda telah terhubung dengan agen kami. Ada yang bisa saya bantu?',
    agentOffline: 'Agen sedang luring',
    agentOfflineMessage: 'Maaf, agen kami sedang luring. Pindai kode QR di bawah untuk menghubungi kami melalui WeChat.',
    wechatPrompt: 'Pindai untuk WeChat',
    wechatHint: 'Gunakan WeChat untuk memindai dan menambahkan agen',
    serviceHoursLabel: 'Jam layanan: ',
    viewImage: 'Lihat gambar',
    playVideo: 'Putar video',
    closeViewer: 'Tutup',
    downloadFile: 'Unduh',
    fileTypePdf: 'Dokumen PDF',
    fileTypeWord: 'Dokumen Word',
    fileTypeExcel: 'Lembar kerja Excel',
    fileTypePpt: 'Presentasi PowerPoint',
    fileTypeArchive: 'Berkas arsip',
    fileTypeGeneric: 'Berkas',
  },
  leadCard: {
    ariaForm: 'Formulir kontak',
    title: 'Tinggalkan info kontak Anda',
    nameLabel: 'Nama',
    namePlaceholder: 'Nama Anda',
    phoneLabel: 'Telepon',
    phonePlaceholder: 'Nomor telepon Anda',
    phoneError: 'Masukkan nomor telepon yang valid',
    submit: 'Kirim',
    submitting: 'Mengirim…',
    dismiss: 'Nanti saja',
    success: 'Terima kasih! Konsultan kami akan segera menghubungi Anda.',
  },
};
